module.exports = __webpack_public_path__ + "img/R4DM24_Annual_Patch_red_ol_2024_01_10-1_transparent_cropped3.36e53c26.png";